import { useEffect, useState } from 'react'
import { Box } from '../../../../Components/CustomUi/box'
import { Select } from '../../../../Components/CustomUi/Select'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import PageContainer from '../../../../Components/pageContainer'
import { ContainerAssistenteTecnico } from '../equipeAssistenteTecnico2/styles'
import { useGetUsuarioConsultor } from '../../../../services/consultoriaAgricola/tipoConsultor/get'
import { useGetEquipeUsuarios } from '../../../../services/consultoriaAgricola/tipoLiderEquipe/get/novo_index'
import { orderBy } from 'lodash'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { TransferContainer } from '../../../../Components/CustomUi/transferContainer'
import { usePostGerenciarEquipeConsultor } from '../../../../services/consultoriaAgricola/tipoConsultor/post'
import { parseArrayNumeros } from '../../../../utils'
import { AxiosResponse } from 'axios'
import { getEquipe, TypesEquipe } from '../../../../services/Equipe'
import {
  getTipoEquipeConsultorGerenciar,
  TypesTipoEquipeConsultorGerenciar,
} from '../../../../services/consultoriaAgricola/equipConsultorGerenciar'

const EquipeConsultorNovo: React.FC = () => {
  //STATES
  const [nome_consultor_selecionado, setNome_consultor_selecionado] = useState<string>('')
  const [id_consultor_selecionado, setId_consultor_selecionado] = useState<number | null>(null)
  const [open, setOpen] = useState<boolean>(false)
  const [selecionados_add, setSelecionados_add] = useState<string[] | number[]>([])
  const [selecionados_remover, setSelecionados_remover] = useState<string[] | number[]>([])
  const [marcar_todos_add, setMarcar_todos_add] = useState<boolean>(false)
  const [marcar_todos_add_remover, setMarcar_todos_remover] = useState<boolean>(false)
  const [carregando_equipe, setCarregando_equipe] = useState<boolean>(false)
  const [data_equipe, setData_equipe] = useState([])

  //API
  const { data_usuarios_consultor } = useGetUsuarioConsultor()
  const { mutate_salvar_consultor, carregando_salvar_consultor } = usePostGerenciarEquipeConsultor()
  const refetch_data_equipe = async (cod) => {
    setCarregando_equipe(true)
    const resp: AxiosResponse<TypesEquipe> = await getEquipe({
      assistenteTecnicoPermitidoConsultor: cod,
      embed: 'tipo_asistente_tecnico',
      pagination: -1,
    })

    const { itens } = resp.data

    const at = itens.filter((item) => item.assistente_tecnico)
    const tec = itens
    const respGe: AxiosResponse<TypesTipoEquipeConsultorGerenciar> =
      await getTipoEquipeConsultorGerenciar({ codConsultor: cod })

    const dados = respGe.data.itens
    setData_equipe(tec)
    setCarregando_equipe(false)
  }

  function listaDisponiveis() {
    return (data_equipe ?? []).filter((item) => item.cod_consultor === null)
  }
  function listaAdicionados() {
    return (data_equipe ?? []).filter((item) => item.cod_consultor !== null)
  }

  function salvarAlteracao(type: 'add' | 'remover') {
    let todos =
      type === 'add'
        ? listaDisponiveis()?.map((item) => Number(item.cod_func))
        : listaAdicionados()?.map((item) => Number(item.cod_func))

    let lista_usuarios =
      type === 'add'
        ? { assistente_tecnicos_add: marcar_todos_add ? todos : parseArrayNumeros(selecionados_add) }
        : {
            assistente_tecnicos_remover: marcar_todos_add_remover
              ? todos
              : parseArrayNumeros(selecionados_remover),
          }

    mutate_salvar_consultor({
      tipo_acao: type,
      cod_consultor: id_consultor_selecionado,
      refetchGerenciar: () => refetch_data_equipe(id_consultor_selecionado),
      limpar: type === 'add' ? () => setSelecionados_add([]) : () => setSelecionados_remover([]),
      ...lista_usuarios,
    })
  }

  useEffect(() => {
    if (id_consultor_selecionado !== null) {
      refetch_data_equipe(id_consultor_selecionado)
    }
  }, [id_consultor_selecionado])

  console.log(data_equipe, id_consultor_selecionado, nome_consultor_selecionado)

  return (
    <ContainerAssistenteTecnico>
      <PageContainer>
        <TitleH1>Equipe do consultor</TitleH1>

        <Box padding={15} gap={10}>
          <Select
            label='Selecione um consultor para começar'
            width={'40%'}
            placeholder='Selecione um consultor para começar'
            value={nome_consultor_selecionado}
            onChange={setNome_consultor_selecionado}
            onChangeID={setId_consultor_selecionado}
            items={orderBy(data_usuarios_consultor?.itens ?? [], 'usuario_nome')}
            descricaoItem='usuario_nome'
            idItem='cod_usuario'
            open={open}
            trigger={setOpen}
            icon={faUser}
          />

          <div
            style={{
              display: 'flex',
              gap: 40,
              opacity: id_consultor_selecionado === null ? 0.4 : 1,
              marginTop: 5,
            }}
          >
            <TransferContainer
              title='Assistentes técnicos disponíveis'
              height={'calc(100vh - 275px)'}
              items={listaDisponiveis()}
              descriptionItem={'usuario_nome'}
              targetItem={'cod_func'}
              selecteds={selecionados_add}
              selectItens={setSelecionados_add}
              emptyMessage='Nenhum assistente disponível'
              loadingMessage='Carregando assistentes disponíveis'
              isLoading={carregando_equipe}
              isLoadingBtn={carregando_salvar_consultor}
              markAll={marcar_todos_add}
              setMarkAll={setMarcar_todos_add}
              onChange={() => salvarAlteracao('add')}
            />

            <TransferContainer
              title='Assistentes técnicos Adicionados'
              height={'calc(100vh - 275px)'}
              items={listaAdicionados()}
              descriptionItem={'usuario_nome'}
              targetItem={'cod_func'}
              selecteds={selecionados_remover}
              selectItens={setSelecionados_remover}
              type='remove'
              emptyMessage='Nenhum usuário foi adicionado'
              loadingMessage='Carregando assistentes adicionados'
              isLoading={carregando_equipe}
              isLoadingBtn={carregando_salvar_consultor}
              markAll={marcar_todos_add_remover}
              setMarkAll={setMarcar_todos_remover}
              onChange={() => salvarAlteracao('remover')}
            />
          </div>
        </Box>
      </PageContainer>
    </ContainerAssistenteTecnico>
  )
}

export default EquipeConsultorNovo
